import React, { useEffect, useState } from "react";
import axios from 'axios';
import * as ReactDOM from "react-dom";
import { packageClient } from "@client-shared/services/packageDB/packageClient";
import { SMARTGFX_VERSION } from "@shared/webpackDefines";
import { Menu, Container, Segment, Step, Icon } from "semantic-ui-react";

import "./home.scss";

declare var COMMIT_HASH: string;
declare var BUILD_DATE: string;

export const Home: React.FC = () => {
    const [isAuthEnabled, setAuthEnabled] = useState(false);

    useEffect(() => {
        checkIfAuthEnabled();
    }, []);

    const checkIfAuthEnabled = async () => {
        const res = await axios.get("/api/auth");
        setAuthEnabled(!!res?.data?.authEnabled);
    }

    return (
        <div>
            <Menu inverted className="main-nav">
                <Menu.Item header>
                    <span className="navbar-brand">
                        <a href="/">SMARTGraphics</a>
                    </span>
                </Menu.Item>
                <Menu.Item>
                    <a href="/edit">Edit</a>
                </Menu.Item>
                <Icon name={isAuthEnabled ? "lock" : "unlock"} inverted className="auth_icon"/>
            </Menu>
            <main>
                <Container>
                    <Segment textAlign="center">
                        <h1>SMART Graphics Server</h1>
                        <p>An HTML5 Broadcast Graphics Framework</p>
                        <h2>Version: {SMARTGFX_VERSION}</h2>
                        <p>Commit: {COMMIT_HASH}</p>
                        <p>Build date: {BUILD_DATE}</p>
                        <p>
                            <a href="/changelog.html" target="_blank">
                                View changelog
                            </a>
                        </p>

                        <Step.Group>
                            <Step href="/edit/assetmanager">
                                <Icon name="upload" />
                                <Step.Content>
                                    <Step.Title>Import</Step.Title>
                                    <Step.Description>
                                        Import assets
                                    </Step.Description>
                                </Step.Content>
                            </Step>

                            <Step href="/edit/graphics">
                                <Icon name="edit" />
                                <Step.Content>
                                    <Step.Title>Create</Step.Title>
                                    <Step.Description>
                                        Create graphics
                                    </Step.Description>
                                </Step.Content>
                            </Step>

                            <Step href="/edit/layouts">
                                <Icon name="tv" />
                                <Step.Content>
                                    <Step.Title>Operate</Step.Title>
                                    <Step.Description>
                                        Set up Control Layouts
                                    </Step.Description>
                                </Step.Content>
                            </Step>
                        </Step.Group>
                    </Segment>
                </Container>
            </main>
        </div>
    );
};
